import React, { Component } from "react";
import { Button } from "@blueprintjs/core";
import { SUBMENUS } from "../utils/constants";
import './../css/SubmenuPills.scss';

class SubmenuPills extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: null
    };
  }

  componentDidMount() {
    this.setInitialActiveItem(this.props.pageType);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pageType !== this.props.pageType) {
      this.setInitialActiveItem(this.props.pageType);
    }
  }

  setInitialActiveItem = (pageType) => {
    const items = SUBMENUS[pageType] || SUBMENUS["default"];
    const firstItem = items[0] || null;
    this.setState({ activeItem: firstItem });

    if (firstItem && this.props.handleSubmenuChange) {
      this.props.handleSubmenuChange(firstItem);
    }
  };

  handleClick = (item) => {
    this.setState({ activeItem: item });
    if (this.props.handleSubmenuChange) {
      this.props.handleSubmenuChange(item);
    }
  };

  render() {
    const { isSubmenuVisible, pageType } = this.props;
    const { activeItem } = this.state;

    if (!isSubmenuVisible || !pageType) return null;

    const items = SUBMENUS[pageType] || SUBMENUS["default"];

    return (
      <div className="submenu-pills">
        {items.map((item, index) => (
          <Button
            key={index}
            text={item}
            minimal
            className={`pill-btn ${activeItem === item ? "active-pill" : ""}`}
            onClick={() => this.handleClick(item)}
          />
        ))}
      </div>
    );
  }
}

export default SubmenuPills;
